import React, { useEffect, useState } from "react";

import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

import { ModeCard, VariableCard } from "@/components/atoms";
import { useInsightFilters } from "@/context";
import { InsightResult } from "@/types";
import { filterItems, movementOptions } from "@/utils";

interface MovementViewProps {
  scores: InsightResult[];
}

export const MovementView: React.FC<MovementViewProps> = ({ scores }) => {
  const {
    filters: { scoreType },
  } = useInsightFilters();

  const [mindsets, setMindsets] = useState<InsightResult[]>([]);

  const maxMovementScore = Math.max.apply(
    Math,
    scores
      .filter((x) => x.tag_group === "Movement")
      .map((x) => Number(x[scoreType.value as keyof InsightResult])),
  );
  const minMovementScore =
    scoreType.value === "rate"
      ? Math.min.apply(
        Math,
        scores
          .filter((x) => x.tag_group === "Movement")
          .map((x) => Number(x[scoreType.value as keyof InsightResult])),
      )
      : Math.max(1 - (maxMovementScore - 1), 0);

  const maxScore = Math.max.apply(
    Math,
    scores
      .filter((x) => x.tag_group === "Movement Mindsets")
      .map((x) => Number(x[scoreType.value as keyof InsightResult])),
  );
  const minScore =
    scoreType.value === "rate"
      ? Math.min.apply(
        Math,
        scores
          .filter((x) => x.tag_group === "Movement Mindsets")
          .map((x) => Number(x[scoreType.value as keyof InsightResult])),
      )
      : Math.max(1 - (maxScore - 1), 0);

  useEffect(() => {
    setMindsets(filterItems(scores.filter(x => x.tag_group === 'Movement Mindsets'), scoreType.value));
  }, [scores, scoreType]);


  return (
    <>
      <Grid container size={12} spacing={2}>

        <Grid size={12}>
          <Typography>Movement Modes</Typography>
        </Grid>

        <Grid container size={12}>
          {movementOptions.map((option, idx) => (
            <ModeCard
              key={idx}
              title={option.name}
              modes={option.options}
              variables={scores.filter(x => x.tag_category === option.name)}
              score={scoreType.value}
              minValue={minMovementScore}
              maxValue={maxMovementScore}
            />
          ))}
        </Grid>

        <Grid size={12}>
          <Typography>Movement Behaviours</Typography>
        </Grid>

        <Grid container size={12}>
          {mindsets.map((mindset, index) => (
            <VariableCard
              key={`movement-mindset-${index}`}
              name={mindset.tag_name}
              value={Number(mindset[scoreType.value as keyof InsightResult])}
              score={scoreType.value}
              minValue={minScore}
              maxValue={maxScore}
            />
          ))}
        </Grid>
      </Grid>
    </>
  );
};

export default MovementView;
